export const primaryColor = "#2362a2";
export const secondaryColor = "#1f5f9d";
export const disabledColor = "#d4d4d4";

export const sidebarItem = {
  color: "white",
  whiteSpace: "nowrap",
};
